import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCheckbox,{class:['eewc-checkbox', {
    'eewc-checkbox--normal': !_setup.checked && !_vm.disabled && !_vm.indeterminate,
    'eewc-checkbox--indeterminate': _vm.indeterminate && !_vm.disabled,
    'eewc-checkbox--active': _setup.checked && !_vm.disabled && !_vm.indeterminate,
    'eewc-checkbox--disabled': !!_vm.disabled
  }],attrs:{"refs":"checkbox","indeterminate-icon":_setup.iconIndeterminate,"on-icon":_setup.iconOn,"off-icon":_setup.iconOff,"ripple":false,"disabled":!!_vm.disabled,"label":_vm.label ? _vm.label : '',"indeterminate":!!_vm.indeterminate,"color":_vm.color ? _vm.color : 'accent'},on:{"click":function($event){$event.stopPropagation();}},model:{value:(_setup.checked),callback:function ($$v) {_setup.checked=$$v},expression:"checked"}})
}
var staticRenderFns = []

export { render, staticRenderFns }